export const pagePromptThemes = [
  'memory',
  'family',
  'inspiration',
  'daily life',
  'dreams',
  'lessons',
  'photos',
];

export const pagePrompts = [
  { theme: 'memory', prompt: 'What place from your past can you still walk through in your mind?' },
  { theme: 'family', prompt: 'What is something a family member taught you without meaning to?' },
  { theme: 'inspiration', prompt: 'Who shaped the way you see the world, and how?' },
  { theme: 'daily life', prompt: 'What ordinary part of today might future you want to remember?' },
  { theme: 'dreams', prompt: 'What future are you quietly building toward?' },
  { theme: 'lessons', prompt: 'What lesson did you learn the hard way?' },
  { theme: 'photos', prompt: 'What picture would explain this season of your life?' },
];

export const tileFormats = ['square', 'compact', 'wide'];

export const calendarStyles = ['tiles', 'month', 'timeline'];

export function todayPagePrompt(date = new Date()) {
  const dayIndex = Math.floor(date.getTime() / 86400000);
  return pagePrompts[dayIndex % pagePrompts.length];
}
